import React from 'react'
import { MainAside } from '../../Components/Aside'
import { emojifyTitle } from '../../helpers'

function FullTeam({ content }) {
  const coreMembers = content.teamMembers.filter(member => {
    return member.role === 'CORE' || member.role === 'TEAM'
  })
  const advisors = content.teamMembers.filter(member => {
    return member.role === 'ADVISOR'
  })
  const collaborators = content.teamMembers.filter(member => {
    return member.role === 'COLLABORATOR'
  })
  const coreMembersAndAdvisors = coreMembers.concat(advisors)
  return (
    <section id={'company'}>
      {content.main && <MainAside content={content.main} />}
      <div className={'midHeading'}>
        <h2>{'Our Core Team'}</h2>
      </div>
      <TileGrid members={coreMembersAndAdvisors} />
      <div className={'midHeading'}>
        <h2>{'Our Collaborators'}</h2>
      </div>
      <TileGrid members={collaborators} />
    </section>
  )
}

function TileGrid({ members }) {
  const tiles = members.map(member => {
    return <Tile key={member.h} member={member} />
  })
  return <div className={'grid-list'}>{tiles}</div>
}

function Tile({ member }) {
  const { h, s, p, img } = member
  const emojifiedTitle = emojifyTitle(s)
  return (
    <div className={'column-container'}>
      <div className={'teamMember-tile'}>
        <img src={img.src} alt={h} />
        <h3>{h}</h3>
        <h4>{emojifiedTitle}</h4>
        <p>{p}</p>
        <SocialList social={member.social} />
      </div>
    </div>
  )
}

function SocialList({ social }) {
  const list = Object.keys(social)
    .filter(key => social[key] !== '')
    .map(key => {
      return (
        // eslint-disable-next-line
        <a key={key} className={`social-button-${key}`} href={social[key]} />
      )
    })
  return <div className={'socialContainer'}>{list}</div>
}

export default FullTeam



// WEBPACK FOOTER //
// ./src/Views/Company/FullTeam.js